module.exports = __webpack_public_path__ + "img/time-out.b6948032.svg";